import S from 'common/service/sanctuary';
import { propEq } from 'ramda';
import { createSelector } from 'reselect';

const getScope = S.prop('stepper');

const getSteps = createSelector(
  getScope,
  S.prop('steps'),
);

export const getStepState = createSelector(
  getSteps,
  steps => stepId => S.find(propEq('stepId', stepId))(steps),
);

export const getData = createSelector(
  getStepState,
  getState => stepId => S.chain(
    state => S.toMaybe(S.prop('data', state)),
    getState(stepId),
  ),
);

export const hasError = createSelector(
  getStepState,
  getState => stepId => S.maybe(
    false,
    S.compose(Boolean, S.prop('error')),
    getState(stepId),
  ),
);

export const getCurrent = createSelector(
  getScope,
  S.prop('current'),
);

export const hasPreviousStep = createSelector(
  getSteps,
  getCurrent,
  getStepState,
  (steps, current, getState) => S.maybe(
    false,
    step => S.maybe(
      false,
      state => !state.disabled,
      getState(step.stepId),
    ),
    S.toMaybe(steps[current - 1]),
  ),
);

export const getCurrentStep = createSelector(
  getCurrent,
  getSteps,
  (current, steps) => S.toMaybe(steps[current]),
);
